<template>
  <createContent/>
</template>

<script>
import createContent from '@/components/_manageposition/_update/update.vue'
export default {
  components: {
    createContent
  }
}
</script>
